// frontend/src/features/production/serialization/store/serializationStore.ts
//
// Small Zustand store holding the operator's "current station" context, so
// they don't have to reselect the work center / work order on every screen
// (register → trace → feed-sessions are all used back-to-back at one
// physical station during a shift).

import { create } from "zustand";

interface SerializationStoreState {
  workCenterId: string | null;
  workOrderId: string | null;
  routingOperationId: string | null;
  setStation: (params: {
    workCenterId?: string | null;
    workOrderId?: string | null;
    routingOperationId?: string | null;
  }) => void;
  clearStation: () => void;
}

export const useSerializationStore = create<SerializationStoreState>((set) => ({
  workCenterId: null,
  workOrderId: null,
  routingOperationId: null,
  setStation: (params) =>
    set((state) => ({
      workCenterId: params.workCenterId !== undefined ? params.workCenterId : state.workCenterId,
      workOrderId: params.workOrderId !== undefined ? params.workOrderId : state.workOrderId,
      routingOperationId:
        params.routingOperationId !== undefined
          ? params.routingOperationId
          : state.routingOperationId,
    })),
  clearStation: () => set({ workCenterId: null, workOrderId: null, routingOperationId: null }),
}));
